export default "__VITE_ASSET__ef77861a__"